// skip-shop-pay.js
document.addEventListener('click', function(e) {
  // Check for <button name="checkout"> OR <a> with checkout href
  const btn = e.target.closest('button[name="checkout"], a[href="/checkout"]');
  if (!btn) return;

  e.preventDefault(); // stop default navigation
  window.location.href = '/checkout?skip_shop_pay=true';
});